import { useAuthStore } from "./auth";
import { useNotificationStore } from "./notification";
import { useFiltersStore } from "./filters";
import { createPinia } from "pinia";

const pinia = createPinia();
export default pinia;

export { useAuthStore, useNotificationStore, useFiltersStore };
